(function() {
  'use strict';

  var drawer = null;

  function getDrawer() {
    if (!drawer) drawer = document.querySelector('[data-nb-cart-drawer]');
    return drawer;
  }

  function getBody() {
    var d = getDrawer();
    return d ? d.querySelector('[data-nb-cart-body]') : null;
  }

  /* Bestandsgrenze parsen: leer/kein Tracking → null (unbegrenzt). */
  function parseMaxAttr(v) {
    if (v === '' || v === null || v === undefined) return null;
    var n = parseInt(v, 10);
    return isNaN(n) ? null : Math.max(0, n);
  }

  /* Andere Komponenten (z.B. Produktseite) über Cart-Änderungen informieren. */
  function dispatchCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('nb:cart:updated', { detail: cart || null }));
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function() {
      d.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    setTimeout(function() {
      d.hidden = true;
      document.body.style.overflow = '';
    }, 250);
  }

  function refreshDrawer() {
    return fetch('/?sections=nb-cart-drawer-contents', {
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    })
      .then(function(r) {
        if (!r.ok) throw new Error('Section render HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var html = data['nb-cart-drawer-contents'];
        if (!html) throw new Error('Section data empty');
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var sectionWrap = doc.body.querySelector('.shopify-section') || doc.body;
        var bodyEl = getBody();
        if (bodyEl) bodyEl.innerHTML = sectionWrap.innerHTML;
      })
      .catch(function(err) {
        console.warn('NB Cart Drawer refresh failed:', err);
        window.location.reload();
      });
  }

  function updateCartCount(count) {
    var els = document.querySelectorAll('[data-nb-cart-count]');
    els.forEach(function(el) {
      el.textContent = count;
      el.hidden = (count === 0);
    });
  }

  function changeQty(lineKey, newQty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        dispatchCartUpdated(cart);
        return refreshDrawer();
      });
  }

  function init() {
    var d = getDrawer();
    if (!d) return;

    /* Event Delegation auf dem stabilen Drawer-Element.
       Listeners überleben innerHTML-Replacements des Body. */
    d.addEventListener('click', function(e) {
      if (e.target.closest('[data-nb-cart-close]')) {
        closeDrawer();
        return;
      }

      var qtyBtn = e.target.closest('[data-nb-qty-change]');
      if (qtyBtn) {
        if (qtyBtn.disabled) return;
        var item = qtyBtn.closest('[data-nb-cart-item]');
        if (!item) return;
        var lineKey = item.getAttribute('data-line-key');
        var qtyDisplay = item.querySelector('[data-qty-display]');
        var currentQty = qtyDisplay ? parseInt(qtyDisplay.textContent, 10) : 1;
        var direction = parseInt(qtyBtn.getAttribute('data-direction'), 10);
        var max = parseMaxAttr(item.getAttribute('data-nb-max'));
        var newQty = Math.max(0, currentQty + direction);
        /* Nie über den verfügbaren Bestand hinaus. */
        if (max !== null && newQty > max) newQty = max;
        if (newQty === currentQty) return;
        changeQty(lineKey, newQty);
        return;
      }

      var removeBtn = e.target.closest('[data-nb-remove]');
      if (removeBtn) {
        var itemEl = removeBtn.closest('[data-nb-cart-item]');
        if (!itemEl) return;
        var key = itemEl.getAttribute('data-line-key');
        changeQty(key, 0);
        return;
      }
    });

    document.querySelectorAll('[data-nb-cart-open]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && d.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    /* Add-to-Cart Intercept · Capture-Phase damit Minimog's eigener
       Submit-Handler nicht parallel feuert (sonst doppelter Add). */
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var formData = new FormData(form);
      var variantId = formData.get('id');
      var addQty = parseInt(formData.get('quantity'), 10);
      if (isNaN(addQty) || addQty < 1) addQty = 1;

      /* Falls das Formular eine Bestandsgrenze kennt (Produktseite),
         vor dem Hinzufügen prüfen: nie über den Bestand hinaus. */
      var maxEl = form.querySelector('[data-nb-pa-max]');
      var max = maxEl ? parseMaxAttr(maxEl.getAttribute('data-nb-pa-max')) : null;

      function doAdd() {
        return fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(function(r) {
            if (!r.ok) { throw new Error('add.js HTTP ' + r.status); }
            return r.json();
          })
          .then(function() {
            return fetch('/cart.js').then(function(r) { return r.json(); });
          })
          .then(function(cart) {
            updateCartCount(cart.item_count);
            dispatchCartUpdated(cart);
            return refreshDrawer();
          })
          .then(function() {
            openDrawer();
          })
          .catch(function(err) {
            console.warn('NB Cart Drawer add-to-cart failed:', err);
          });
      }

      if (max !== null && variantId) {
        /* Aktuelle Menge dieser Variante im Warenkorb ermitteln. */
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var inCart = 0;
            (cart.items || []).forEach(function(it) {
              if (String(it.variant_id) === String(variantId)) inCart += it.quantity;
            });
            if (inCart + addQty > max) {
              /* Bestand erreicht — nicht hinzufügen, nur Zustand aktualisieren. */
              dispatchCartUpdated(cart);
              openDrawer();
              return;
            }
            return doAdd();
          })
          .catch(function() { return doAdd(); });
      } else {
        doAdd();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
